import { gql } from '@apollo/client';

export default gql`
  query getUi {
    getUi {
      promoCodeDetails @client
    }
  }
`;
